var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('empty-state',{attrs:{"icon":"hourglass","title":"Hang On A Sec...","subtitle":"We're just loading your details. Won't be a moment."}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }